import Programs from "./pages/ngo-programs/store";
import Activities from "./pages/ngo-activities/store";

export default {
  namespaced: true,
  modules: {
    Programs,
    Activities,
  },
};
